import { renderTitle, useBreadcrumbs } from '@/_shared/hooks/useBreadcrumbs';
// import envConfig from '@/_shared/models/enviroment.model';
import Head from 'next/head';
import Link from 'next/link';
import React, { forwardRef, HTMLAttributes, useMemo } from 'react';

const Breadcrumbs = React.memo(
  forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>((props, ref) => {
    const breadcrumbs = useBreadcrumbs();

    // Avoid unnecessary re-renders
    const title = useMemo(
      () =>
        breadcrumbs.length
          ? `MeterCube${renderTitle(breadcrumbs)}`
          : `MeterCube`,
      [breadcrumbs]
    );

    const bypassList = ['/category-insights', '/tradewinds'];

    return (
      <>
        <Head>
          <title>{title}</title>
        </Head>
        <div {...props} ref={ref}>
          {breadcrumbs.map((t, i) => (
            <span key={t.href}>
              {i !== breadcrumbs.length - 1 ? (
                <div className="flex items-center">
                  {bypassList.includes(t.href) ? (
                    <span>{t.label}</span>
                  ) : (
                    <Link className="hover:text-main-hover" href={t.href}>
                      {t.label}
                    </Link>
                  )}
                  <span className="mx-3">/</span>
                </div>
              ) : (
                <div className="font-semibold">{t.label}</div>
              )}
            </span>
          ))}
        </div>
      </>
    );
  })
);

Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
